import { styled } from '@mui/system';
import images from 'src/config/images';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { Box, alpha, Avatar } from '@mui/material';
import theme, { palette, shadows, typography } from 'src/config/theme';




// export const SidebarOnOffContainer = styled(Box)({
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   position: 'absolute',
//   top: '56px',
//   left: '252px',
//   width: '56px',
//   height: '56px',
//   borderRadius: '40px',
//   padding: '10px',
//   backgroundColor: palette.primary.light3,
//   zIndex: '100000',
//   boxShadow: shadows[1],
// })
export const SidebarOnOffContainer = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'isPermanentOpen',
})(({ isPermanentOpen }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'fixed',
  top: '56px',
  left: isPermanentOpen ? '252px' : '60px',
  width: '56px',
  height: '56px',
  borderRadius: '40px',
  padding: '10px',
  backgroundColor: palette.primary.light3,
  zIndex: '100000',
  boxShadow: shadows[1],
  transition: 'left 0.3s ease-in-out',
  color: palette.primary.main
}));

export const AuthContainer = styled(Container)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end', // Aligns the form to the right
  width: '100%',
  maxWidth: '100% !important',
  height: '100vh',
  padding: '0 !important',
  margin: 0,
  backgroundColor: '#f5f7fa',
});

export const AuthBg = styled('div')({
  // marginTop: 60,
  flex: 1,
  borderRadius: 16,
  background: `url(${images.auth.authBg})`,
  minHeight: 'calc(100vh - 120px)',
  height: 'calc(100vh - 120px)',
  backgroundSize: 'cover',
  '& > .MuiGrid-root': {
    height: '100%',
  },
  padding: 16,
});

export const Left = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  flexDirection: 'column',
  position: 'relative',


});

export const Right = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const AuthContent = styled('div')(({ theme }) => ({
  borderRadius: '24px',
  border: `1px solid ${alpha(theme.palette.gery.black, 0.10)}`,
  background: theme.palette.gery.white,
  boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
  padding: '40px 30px',
  width: '380px',
  maxWidth: '90vw',
  [theme.breakpoints.down('sm')]: {
    padding: '30px 20px',
    width: '95vw',
  },
}));

// export const Logo = styled('img')({});
// Logo.defaultProps = {
//   src: images.logoW,
//   width: '500px'
// };

export const Logo = styled('img')(({ theme }) => ({
  width: '500px',
  [theme.breakpoints.down('md')]: {
    width: '400px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '300px',
  },
  [theme.breakpoints.down('xs')]: {
    width: '200px',
  },
  // width: '100%',
  // maxWidth: '500px',
  // height: 'auto'

}));

Logo.defaultProps = {
  src: images.logoW,
};

export const Icon1 = styled('img')({
  position: 'absolute',
  bottom: '-10px',
  right: '00px',
});
Icon1.defaultProps = {
  src: images.auth.icon,
};

export const Icon2 = styled('img')({});
Icon2.defaultProps = {
  src: images.auth.login1,
};
